import { SelectInput } from 'client/components/common/SelectInput/SelectInput'
import { StateInterface } from 'client/Interfaces/StateInterface'
import { l } from 'client/Other/Translation'
import * as React from 'react'
import { connect } from 'react-redux'

import './styles.scss'

const IBANSelector = ({ schema, paymentMeans, paymentMethodsInSettings, onChange }) => {
  const IBAN = paymentMeans.find(({ type }) => type === 'IBAN')
  const hasIBAN = Boolean(IBAN)
  const ibanFromSettings = paymentMethodsInSettings.find(({ type }) => type === 'IBAN')
  if (!ibanFromSettings) {
    return null
  }
  const ibansFromSettings = [ibanFromSettings.fields]
  if (ibanFromSettings.optionalIBANs) {
    ibanFromSettings.optionalIBANs.forEach((ibanFields) => ibansFromSettings.push(ibanFields))
  }
  const couldFindIban = hasIBAN && ibansFromSettings.find(({ iban }) => iban === IBAN.fields.iban)
  const IBANSelectorRef = React.useRef()
  React.useEffect(() => {
    if (hasIBAN && !couldFindIban && IBANSelectorRef.current) {
      IBANSelectorRef.current.scrollIntoView()
    }
  }, [couldFindIban, IBANSelectorRef.current])
  const selectedIBAN = couldFindIban ? IBAN : ibanFromSettings
  return (
    <div ref={IBANSelectorRef} className="ibanSelector">
      {hasIBAN && !couldFindIban && (
        <div className="ibanSelector-ibanNotFound">{l('invoiceEditor.paymentMethods.IBAN.notFound')}</div>
      )}
      {ibansFromSettings.length > 1 ? (
        <SelectInput
          value={selectedIBAN.fields.iban}
          map={ibansFromSettings.reduce((ibansMapped, { iban, bank }) => {
            ibansMapped[iban] = (
              <div value={iban}>
                {iban}
                <br />
                {bank}
              </div>
            )
            return ibansMapped
          }, {})}
          onChange={(newIban) => {
            const newIbanFromSettings = ibansFromSettings.find(({ iban }) => iban === newIban)
            onChange(newIbanFromSettings)
          }}
        ></SelectInput>
      ) : (
        <div className="PaymentMethod">{ibansFromSettings[0].iban}</div>
      )}
      {schema.fields.map((f) => {
        if (IBAN && IBAN.fields[f.name] && f.name !== 'iban') {
          const pmKey = `IBAN_${f.name}`
          return (
            <div className="PaymentMethod" key={pmKey}>
              {l(f.label)}: {selectedIBAN.fields[f.name]}
            </div>
          )
        }
      })}
    </div>
  )
}

export default connect(
  ({ settings }: StateInterface) => ({
    paymentMethodsInSettings: settings.values.paymentMethods,
  }),
  null,
)(IBANSelector)
